import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './TabMenu.module.css';
import { ICON_PATHS } from '../../../../constants/iconPaths';

function TabMenu() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <nav className={styles.bottomTabBar}>
      <Link 
        to="/project/plabthon" 
        className={`${styles.tabItem} ${currentPath === '/project/plabthon' ? styles.active : ''}`}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          {ICON_PATHS.home.paths.map((pathData, index) => (
            <path
              key={index}
              d={pathData.path}
              fillRule={pathData.fillRule}
              clipRule={pathData.clipRule}
              fill="currentColor"
            />
          ))}
        </svg>
        <span>홈</span>
      </Link>
      <Link 
        to="/project/plabthon/product-ranking" 
        className={`${styles.tabItem} ${currentPath === '/project/plabthon/product-ranking' ? styles.active : ''}`}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          {ICON_PATHS.rocket.paths.map((pathData, index) => (
            <path
              key={index}
              d={pathData.path}
              fillRule={pathData.fillRule}
              clipRule={pathData.clipRule}
              fill="currentColor"
            />
          ))}
        </svg>
        <span>프로덕트 순위</span>
      </Link>
      <Link 
        to="/project/plabthon/researcher-ranking" 
        className={`${styles.tabItem} ${currentPath === '/project/plabthon/researcher-ranking' ? styles.active : ''}`}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          {ICON_PATHS.flame.paths.map((pathData, index) => (
            <path
              key={index}
              d={pathData.path}
              fillRule={pathData.fillRule}
              clipRule={pathData.clipRule}
              fill="currentColor"
            />
          ))}
        </svg>
        <span>개인 순위</span>
      </Link>
      <Link 
        to="/project/plabthon/my" 
        className={`${styles.tabItem} ${currentPath === '/project/plabthon/my' ? styles.active : ''}`}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          {ICON_PATHS.person.paths.map((pathData, index) => (
            <path
              key={index}
              d={pathData.path}
              fillRule={pathData.fillRule}
              clipRule={pathData.clipRule}
              fill="currentColor"
            />
          ))}
        </svg>
        <span>MY</span>
      </Link>
    </nav>
  );
}

export default TabMenu;